import * as Crypto from 'crypto-js';

const KEY = Crypto.enc.Utf8.parse(import.meta.env.VITE_REACT_AES_KEY);
const IV = Crypto.enc.Utf8.parse(import.meta.env.VITE_REACT_AES_IV);

export const aesEncryptCBC = (data: string): string => {
  const cipher = CryptoJS.AES.encrypt(data, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return cipher.toString();
};

export const aesDecryptCBC = (data: string): string => {
  try {
    const preDecrypt = Crypto.AES.decrypt(data, KEY, { iv: IV });
    const decrypted = Crypto.enc.Utf8.stringify(preDecrypt);

    return decrypted.toString();
  } catch (error) {
    return data;
  }
};
